module.exports = __webpack_public_path__ + "img/img-lingfeng.2f938582.png";